import {TranslateService} from '@ngx-translate/core';
import {Injectable} from '@angular/core';
import {IdAndLabel} from '../model/id-and-label';
import {Observable} from 'rxjs';
import {map, startWith, switchMap} from 'rxjs/operators';
import {camelCase} from 'lodash';

@Injectable()
export class EnumsService {
  constructor(private translate: TranslateService) {}

  public enumAsOptions$<EnumType>(enumObject: EnumType, enumName?: string): Observable<IdAndLabel[]> {
    const enumOptions = this.enumToOptions(enumObject, enumName);
    const enumLabels = enumOptions.map(({label}) => label);
    return this.translate.onLangChange.asObservable().pipe(
      startWith(null),
      switchMap(() => this.translate.get(enumLabels)),
      map(translatedLabels => enumOptions.map(({id, label}) => new IdAndLabel(id, translatedLabels[label])))
    );
  }

  public enumAsOptions<EnumType>(enumObject: EnumType, enumName?: string): IdAndLabel[] {
    return this.enumToOptions.apply(this, arguments).map(({id, label}) => new IdAndLabel(id, this.translate.instant(label)));
  }

  private enumToOptions<EnumType>(givenEnumObject: EnumType, givenEnumName?: string): IdAndLabel[] {
    const {enumObject, enumName} = this.extractFrom(givenEnumObject, givenEnumName);
    const enumKeys = Object.keys(enumObject) as (keyof EnumType)[];
    return enumKeys.map((key: keyof EnumType) => (
      new IdAndLabel(enumObject[key], (`${enumName}_${enumObject[key]}`))
    ));
  }

  /**
   * Allows you to wrap the Enum in an object {} which will map its
   * name as the key in the object so {MyEnum} becomes
   * { MyEnum: {… actual enum object}}, allowing
   *  the enumName to become optional
   * @param enumObject
   * @param enumName
   * @private
   */
  private extractFrom<EnumType>(enumObject: EnumType, enumName?: string) {
    if (!enumName) {
      enumName = Object.getOwnPropertyNames(enumObject)[0];
      enumObject = enumObject[enumName];
    }
    enumName = camelCase(enumName); // Finally, we need to camelcase it for the translations
    return {enumObject, enumName};
  }
}

